export default __webpack_public_path__ + "images/c66a82fa13587b6a4d3594c538d2d91d-cricket.png";